import React from 'react';
import PropTypes from 'prop-types';
import {Container, Dropdown, Header, Icon} from 'semantic-ui-react';

import HomepageLayout from 'components/homepage-layouts/HomepageLayout';

class EditHomepageLayoutsPage extends React.Component {

  componentDidMount() {
    this.props.getLayouts({});
  }

  get options() {
    let options = [];

    if ( this.props.layouts ) {
      this.props.layouts.forEach(function(layout) {
        options.push({
          key: layout.id,
          text: layout.name,
          value: layout.id
        });
      })
    }

    return options;
  }

  render() {
    return <Container className="edit-homepage-layouts-page">
              <Header as='h2' icon textAlign='center'>
                <Icon name='grid layout' circular/>
                <Header.Content>
                  Homepage Layouts
                </Header.Content>
              </Header>
              <div>
                <Dropdown search
                        selection
                        placeholder='Select layout...'
                        onChange={this.props.onLayoutSelection}
                        options={this.options}  />
              </div>
              {this.props.selectedLayout ?
                <HomepageLayout layout={this.props.selectedLayout}  />
              : "" }
          </Container>

  }

}

export default EditHomepageLayoutsPage;



// WEBPACK FOOTER //
// ./public/pages/EditHomepageLayoutsPage/EditHomepageLayoutsPage.jsx